import React, { Component } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

export default class ThisWeek extends Component {


  componentDidMount() {
    setTimeout(() => {
      document.querySelector('video').style.opacity = 1
      document.querySelector('video').play()
    }, 1000);

  }

  render() {
    return (
      <ReactCSSTransitionGroup
        transitionName="FadeIn"
        transitionAppear={true}
        transitionAppearTimeout={1000}
        transitionEnterTimeout={1000}
        transitionLeaveTimeout={1000}
        className="landing"
        component="section"
      >
      <video width="50%" height="auto" autoPlay="true" playsInline="true">
        <source src={require('../assets/images/video.m4v')} type="video/mp4" />
      </video>


      <div className='asocial-smiley'></div>
      </ReactCSSTransitionGroup>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/landing.js